import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fc-d" }

import { reactive, onMounted } from 'vue';
import { useRouter } from 'vue-router';

import { GbTables } from '@/components/GbTables';
import { useGbTable } from '@/hooks/useGbTable';
import { formatTools } from '../../../utils/index';
import { saveAs } from 'file-saver';
import { ElMessage } from 'element-plus';
import { useCtCategory } from '@/store/category.store';
import { useDictionary } from '@/store/dictionary.store';
// 添加多语言支持
import { useLocales } from '@/hooks/useLocales';

import { GetPerformReportApi, ContractPerformExportApi } from '../../../apis/reports/apis';
import {GetTradeCacheListApi} from "@/apis/basics/trade.api";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useLocales();

const { register, tableObject, methods } = useGbTable<any>({
	getListApi: GetPerformReportApi,
	response: { data: 'data', total: 'total' },
});

const { push } = useRouter();
const { getName, getSelectList } = useDictionary();
const { fDateTime, fDate, fAmount } = formatTools();

/* 数据Table绑定设置 */
const tabColumns = reactive<any[]>([
	{ field: 'status', label: t('contractList.table.status', '合同状态'), columnWidth: '80', align: 'center' },
	{ field: 'no', label: t('contract.no', '合同编号'), columnWidth: '140', align: 'center' },
	{ field: 'name', label: t('contract.name', '合同名称'), columnWidth: '160', headerAlign: 'center' },


	{ field: 'mainstay_name', label: t('reports.performs.table.ourParty', '我方主体(甲方)'), headerAlign: 'center', columnWidth: '240' },
	{ field: 'counterpart_name', label: t('reports.performs.table.counterpart', '相对方(乙方)'), headerAlign: 'center', columnWidth: '240' },
	{ field: 'category_name', label: t('draft.contractCategory', '合同分类'), headerAlign: 'center', columnWidth: '300' },
	{ field: 'time_limit', label: t('draft.contractTerm', '合同期限'), columnWidth: '180', align: 'center' },
	{ field: 'contract_amount', label: t('draft.contractAmount', '合同金额'), columnWidth: '120', align: 'right' },
	{ field: 'payment', label: t('reports.performs.table.paymentMethod', '支付方式'), columnWidth: '100', align: 'center' },
	{ field: 'unpay_amount', label: t('reports.performs.table.unpaidAmount', '未付金额'), columnWidth: '120', align: 'right' },
	{ field: 'audit_amount', label: t('reports.performs.table.auditAmount', '审批中金额'), columnWidth: '120', align: 'right' },
	{ field: 'wait_amount', label: t('reports.performs.table.pendingPaymentAmount', '待付款金额'), columnWidth: '120', align: 'right' },
	{ field: 'pay_amount', label: t('reports.performs.table.paidAmount', '已付款金额'), columnWidth: '120', align: 'right' },

	/* 不知道以后用不用得上，如果用得上是最好了 Remark by 摸鱼王 2024年3月19日 */
	// { field: 'err_amount', label: '付款异常金额', columnWidth: '200', align: 'center' },
	// { field: 'back_amount', label: '退回申请金额', columnWidth: '200', align: 'center' },

	{ field: 'created_name', label: t('contractList.table.creator', '创建人'), columnWidth: '120', fixed: 'right', align: 'center' },
	{ field: 'created_time', label: t('draft.createdTime', '创建时间'), columnWidth: '120', fixed: 'right', align: 'center' },
	{ field: 'action', width: '100', label: t('contractList.table.action', '操作'), fixed: 'right', align: 'center' },
]);

const state = reactive({
  disabledPartyb: false,
	loading: false,
	dlLoading: false,
	queryParams: {} as any,
	categoryList: [] as any[],
  parytBList: [] as any[],
	pagedParams: { page_size: 10, current: 1 } as any,
});

const load = {
  /* 获取相对方数据 */
  getPartybList: async () => {
    state.disabledPartyb = true;
    const { succeeded, errors, data } = await GetTradeCacheListApi();
    if (!succeeded) {
      ElMessage.error(errors);
    } else {
      state.parytBList = (data || []).map((pb: any) => {
        return { label: pb.name, value: pb.id };
      });
    }
    state.disabledPartyb = false;
  },
};




const actions = {
	onSearch: () => {
		const search = Object.assign(state.queryParams, state.pagedParams);
		methods.setSearchParams(search);
	},

	reSet: () => {
		state.queryParams = { name: '' };
		actions.onSearch();
	},
	showDetail: (row: any) => {
		push({ path: `/contracts/previews`, query: { contractId: `${row.id}` } });
	},
	/* 导出Excel */
	exports: async () => {
		state.dlLoading = true;
		const search = Object.assign(state.queryParams, state.pagedParams);
		await ContractPerformExportApi(search)
			.then((res: any) => {
				const { status, data } = res;
				if (status != 200) ElMessage.error(t('reports.performs.message.exportFailed', '导出失败，请联系管理员'));
				else {
					const blob = new Blob([data]);
					const title = `${t('reports.performs.title.contractPerformanceReport', '合同履约统计表')}.xlsx`;
					saveAs(blob, title);
				}
			})
			.catch((err) => {
				ElMessage.error(err);
			})
			.finally(() => {
				state.dlLoading = false;
			});
	},
};

onMounted(() => {
	state.categoryList = useCtCategory().getTreeList();

	const search = Object.assign(state.queryParams, state.pagedParams);
	methods.setSearchParams(search);
  load.getPartybList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tree_select = _resolveComponent("el-tree-select")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, {
      shadow: "never",
      "body-style": { paddingBottom: '0' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          size: "small",
          model: _unref(state).queryParams,
          inline: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('contract.no', '合同编号')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _unref(state).queryParams.no,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).queryParams.no) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('contract.name', '合同名称')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _unref(state).queryParams.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).queryParams.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('draft.contractCategory', '合同分类')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tree_select, {
                  style: {"width":"100%"},
                  modelValue: _unref(state).queryParams.category_id,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).queryParams.category_id) = $event)),
                  data: _unref(state).categoryList,
                  accordion: "",
                  filterable: "",
                  clearable: "",
                  placeholder: _unref(t)('reports.performs.form.contractCategoryPlaceholder', '请选择合同分类')
                }, null, 8, ["modelValue", "data", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('reports.performs.form.counterpart', '相对方')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select_v2, {
                  modelValue: _unref(state).queryParams.counterpart_id,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).queryParams.counterpart_id) = $event)),
                  clearable: "",
                  options: _unref(state).parytBList,
                  disabled: _unref(state).disabledPartyb,
                  filterable: ""
                }, null, 8, ["modelValue", "options", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      icon: "Search",
                      type: "primary",
                      onClick: actions.onSearch
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('buttons.search', '查询')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_button, {
                      icon: "RefreshRight",
                      onClick: actions.reSet
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('buttons.cancel', '重置')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_button, {
                      icon: "Download",
                      disabled: _unref(state).dlLoading,
                      onClick: actions.exports
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('buttons.export', '导出')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(_component_el_form, {
          size: "small",
          model: _unref(state).queryParams,
          inline: true
        }, null, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"10px"},
      disabled: _unref(tableObject).loading
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(GbTables), {
          pageSize: _unref(tableObject).pageSize,
          "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
          currentPage: _unref(tableObject).currentPage,
          "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
          columns: _unref(tabColumns),
          data: _unref(tableObject).tableList,
          loading: _unref(tableObject).loading,
          pagination: { total: _unref(tableObject).total },
          onRegister: _unref(register)
        }, {
          action: _withCtx(({ row }) => [
            _createVNode(_component_el_button, {
              icon: "Memo",
              type: "primary",
              size: "small",
              text: "",
              onClick: ($event: any) => (actions.showDetail(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('buttons.detail', '详 细')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          status: _withCtx(({ row }) => [
            _createVNode(_component_el_tag, { size: "small" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getName)('contract_status', row.status)), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          created_time: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(fDateTime)(row.created_time)), 1)
          ]),
          created_name: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(`${row.created_name}(${row.created_user_id})`), 1)
          ]),
          payment: _withCtx(({ row }) => [
            _createVNode(_component_el_tag, { size: "small" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getName)('contract_payment', row.payment)), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          time_limit: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(fDate)(row.begin_day)) + " ~ " + _toDisplayString(_unref(fDate)(row.end_day, _unref(t)('draft.noFixedTerm', '无固定期限'))), 1)
          ]),
          contract_amount: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(fAmount)(row.contract_amount)), 1)
          ]),
          unpay_amount: _withCtx(({ row }) => [
            _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(fAmount)(row.unpay_amount)), 1)
          ]),
          audit_amount: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(fAmount)(row.audit_amount)), 1)
          ]),
          wait_amount: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(fAmount)(row.wait_amount)), 1)
          ]),
          pay_amount: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(fAmount)(row.pay_amount)), 1)
          ]),
          _: 1
        }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
      ]),
      _: 1
    }, 8, ["disabled"])
  ], 64))
}
}

})